import { render, staticRenderFns } from "./RasPazienteScaleValutazioneListComponent.vue?vue&type=template&id=17b006d4"
import script from "./RasPazienteScaleValutazioneListComponent.vue?vue&type=script&lang=js"
export * from "./RasPazienteScaleValutazioneListComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports